import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';

import { AuthLayout } from '@/app/auth';
import { useBrand } from '@/shared/brand';
import { useConfig } from '@/shared/config';
import { FieldConfigProvider } from '@/shared/ui/field-config';

export const Route = createFileRoute('/login')({
  component: GuestLayout,
});

/**
 * `GuestLayout` do legado, redesenhado: palco de marca e formulário (`AuthLayout`). O `FORM_FIELDS`
 * do tenant não vale aqui: o campo `email` de pessoa não pode esconder o e-mail do login.
 */
function GuestLayout() {
  const brand = useBrand();
  const config = useConfig();
  // A chave da animação de entrada é a rota já resolvida: a `location` muda no começo da navegação, e o
  // formulário remontava vazio enquanto a Início carregava depois do MFA (parecia pedir o código de novo).
  const path = useRouterState({ select: (s) => (s.resolvedLocation ?? s.location).pathname });
  return (
    <AuthLayout brand={brand} mfa={Boolean(config.USE_MFA)} contentKey={path}>
      <FieldConfigProvider config={undefined}>
        <Outlet />
      </FieldConfigProvider>
    </AuthLayout>
  );
}
